import appUiReducer from './app-ui';
import questionnaireReducer from './questionnaires';
import authReducer from './auth';

export const initialState = {};

export default {
  voting: questionnaireReducer,
  auth: authReducer,
  appUi: appUiReducer
};
